<template>
  <main>
    <div v-if="currentUser" class="Meritos">
      <headerFeed :currentUser="currentUser" title="Mis Meritos"></headerFeed>
      <md-progress v-if="loading" class="md-accent" md-indeterminate></md-progress>
      <router-view class="contenidoPagina"></router-view>
    </div>
  </main>
</template>

<script>

import header from './Header'
import FluxerService from '../services/fluxer'
import ObjetivosService from '../services/objetivos'
import NotificationsService from '../services/notifications'
import Autocomplete from './Autocomplete'
import Acuerdo from './Acuerdo'
import Router from '../router'
import _ from 'lodash'

export default {
  name: 'mis-objetivos',
  components: {
    'headerFeed': header,
    'autocomplete': Autocomplete,
    'acuerdo': Acuerdo
  },
  data () {
    return {
      currentUser: FluxerService.getCurrentUser(),
      liderSelected: '',
      loading: false,
      loader: true,
      error: false
    }
  },
  computed: {
    acuerdoVigente: function () {
      return _.find(this.misAcuerdos, function (o) { return !o.finalizado })
    },
    acuerdosArchivados: function () {
      return _.filter(this.misAcuerdos, function (o) { return o.finalizado })
    }
  },
  firebase: function () {
    return {
      allLideres: FluxerService.getLideres(),
      misAcuerdos: {
        source: ObjetivosService.getByEmailOwner(this.currentUser.email),
        readyCallback: function () {
          this.loader = false
        }
      }
    }
  },
  methods: {
    openSelectFluxer (ref) {
      this.$refs[ref].open()
    },
    confirmDialog (ref) {
      let liderSelected = this.liderSelected
      let liderObjectSelect = _.find(this.allLideres, function (o) { return o.displayName === liderSelected })
      if (liderObjectSelect) {
        let currentUser = this.currentUser
        this.closeDialog(ref)
        this.loading = true
        ObjetivosService.createAcuerdo(liderObjectSelect.email, this.currentUser.email).then((resp) => {
          if (!resp.data.hayVigente) {
            NotificationsService.solicitarObjetivos(resp.data.acuerdoId, liderObjectSelect.email, currentUser)
          } else {
            this.$refs.advertencia.open()
          }
          this.loading = false
        })
      } else {
        this.error = true
      }
    },
    closeDialog (ref) {
      this.liderSelected = ''
      this.error = false
      this.$refs[ref].close()
    },
    verVigente (ref) {
      this.openDetail()
      this.closeDialog(ref)
    },
    openDetail (acuerdo) {
      if (!acuerdo) {
        acuerdo = this.acuerdoVigente
      }
      if (acuerdo.sent) {
        let lider = _.find(this.allLideres, function (o) { return o.email === acuerdo.editor })
        Router.push({name: 'mi-acuerdo-detail', params: {id: acuerdo['.key'], fluxerSelected: lider}})
      } else {
        this.$refs.advertenciaAcuerdo.open()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .set-objetivos {
        position: fixed !important; 
        right: 10px; 
        bottom: 10px;
        width: 56px !important;
        height: 56px !important; 
        z-index: 10;
    }

    .md-error {
      color: red;
      top: -32px;
      position: inherit;
    }
    
  .contenidoPagina {
    padding-top: 64px;
  }    
</style>



// WEBPACK FOOTER //
// MisMeritos.vue?47dbaff4